import React, { useEffect } from 'react'
import { Route, Switch, useHistory } from 'react-router-dom'

import ChangePassword from 'account/changePassword'
import { LOGIN_PATH } from 'account/login/Login'

import { User } from 'core/application/account/loginUser'
import { Permissions } from 'core/application/account/permissions'

import useLoginUser from 'common/hooks/useLoginUser'

import NotFound from 'errorPages/NotFound'

import { ROUTE_PATHS } from '../common/routePaths'
import MyProfile from '../employeeDashboard/common/employeeProfile'
import NonEligibleEmployeeDashboardWrapper, { MenuItem } from './NonEligibleEmployeeDashboardWrapper'
import Dashboard from './home/index'

export const NON_ELIGIBLE_EMPLOYEE_DASHBOARD_PATH = '/non-eligible-employee-dashboard'

export enum NavigationMapping {
  Dashboard = 1,
  MyProfile = 2,
  ChangePassword = 3,
}

export const navigationPathMapping = new Map<string, number>([['/', NavigationMapping.Dashboard]])

export const navigationMenu: MenuItem[] = [
  {
    name: 'menu.dashboard',
    key: NavigationMapping.Dashboard,
    path: NON_ELIGIBLE_EMPLOYEE_DASHBOARD_PATH,
    icon: 'dashboard',
    component: Dashboard,
  },
]

interface NonEligibleEmployeeDashboardProps {}

const NonEligibleEmployeeDashboard: React.FC<NonEligibleEmployeeDashboardProps> = () => {
  const history = useHistory()
  const [user] = useLoginUser()
  useEffect(() => {
    if (!isUserAllowedToEnterDashboard(user)) history.push(LOGIN_PATH)
  })

  const isUserAllowedToEnterDashboard = (user: User): boolean => {
    return user !== null && user.permissions.includes(Permissions.AccessNonEligibleEmployeeDashboard)
  }

  return (
    user && (
      <NonEligibleEmployeeDashboardWrapper user={user}>
        <Switch>
          <Route
            key={NavigationMapping.MyProfile}
            path={`${ROUTE_PATHS.NON_ELIGIBLE_EMPLOYEE_PROFILE}`}
            component={MyProfile}
          />
          <Route key={NavigationMapping.ChangePassword} path={ROUTE_PATHS.NON_ELIGIBLE_EMPLOYEE__CHANGE_PASSWORD_PATH}>
            <ChangePassword />
          </Route>
          {navigationMenu
            .sort((first, second) => second.key - first.key)
            .map((item: MenuItem) => (
              <Route key={item.key} path={item.path} component={item.component} />
            ))}
          <Route>
            <NotFound />
          </Route>
        </Switch>
      </NonEligibleEmployeeDashboardWrapper>
    )
  )
}

export default NonEligibleEmployeeDashboard
